import { Col, Row, Switch } from 'antd';
import React from 'react';
import CustomInput from '../../../../../../components/CustomInput/CustomInput';
import CustomSelect from '../../../../../../components/CustomSelect/CustomSelect';

const criiptoColorsOptions = [
    { id: 'default', value: 'default', label: 'Default' },
    { id: 'branded', value: 'branded', label: 'Branded' },
];

export default function WhiteLabelInputs({
    data,
    theme,
    onChangeColors,
    onThemeChange,
    selectOptionsThemes,
    errors,
    selectLoginButtonsStyles,
    selectedLoginButtonsStyles,
}) {
    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Theme
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomSelect
                                name="themes"
                                onChange={onThemeChange}
                                options={selectOptionsThemes}
                                placeholder="Select theme"
                                value={theme}
                                errors={errors}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Criipto colors
                        </div>
                    </Col>
                    <Col span={7}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomSelect
                                name="login_buttons_styles"
                                onChange={selectLoginButtonsStyles}
                                options={criiptoColorsOptions}
                                placeholder="Select login buttons colors"
                                value={selectedLoginButtonsStyles}
                                errors={errors}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Graphic colors
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.graphic_colors?.light ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Light
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="716FF4"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'graphic_colors',
                                                color: 'light',
                                            })
                                        }
                                        inputValue={data?.graphic_colors?.light}
                                        width="100%"
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.graphic_colors?.default ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="602DF3"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'graphic_colors',
                                                color: 'default',
                                            })
                                        }
                                        inputValue={
                                            data?.graphic_colors?.default
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.graphic_colors?.dark ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Dark
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="230F5B"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'graphic_colors',
                                                color: 'dark',
                                            })
                                        }
                                        inputValue={data?.graphic_colors?.dark}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Primary button
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button?.default ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="3A29E8"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'primary_button',
                                                color: 'default',
                                            })
                                        }
                                        inputValue={
                                            data?.primary_button?.default
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button?.hover ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="2F1FD1"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'primary_button',
                                                color: 'hover',
                                            })
                                        }
                                        inputValue={data?.primary_button?.hover}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button?.active ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="2013AC"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'primary_button',
                                                color: 'active',
                                            })
                                        }
                                        inputValue={
                                            data?.primary_button?.active
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <span className="details-table__color-title">
                                        Outlined
                                    </span>
                                    <Switch
                                        className="details-table__switch--main"
                                        checked={data?.primary_button?.outlined}
                                        onChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'primary_button',
                                                color: 'outlined',
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Primary button content
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button_content
                                                    ?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'primary_button_content',
                                                color: 'default',
                                            })
                                        }
                                        inputValue={
                                            data?.primary_button_content
                                                ?.default
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button_content
                                                    ?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'primary_button_content',
                                                color: 'hover',
                                            })
                                        }
                                        inputValue={
                                            data?.primary_button_content?.hover
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button_content
                                                    ?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'primary_button_content',
                                                color: 'active',
                                            })
                                        }
                                        inputValue={
                                            data?.primary_button_content?.active
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Secondary button
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button
                                                    ?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'secondary_button',
                                                color: 'default',
                                            })
                                        }
                                        inputValue={
                                            data?.secondary_button?.default
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button?.hover ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="2F1FD1"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'secondary_button',
                                                color: 'hover',
                                            })
                                        }
                                        inputValue={
                                            data?.secondary_button?.hover
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button
                                                    ?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="2013AC"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'secondary_button',
                                                color: 'active',
                                            })
                                        }
                                        inputValue={
                                            data?.secondary_button?.active
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <span className="details-table__color-title">
                                        Outlined
                                    </span>
                                    <Switch
                                        className="details-table__switch--main"
                                        checked={
                                            data?.secondary_button?.outlined
                                        }
                                        onChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'secondary_button',
                                                color: 'outlined',
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Secondary button content
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button_content
                                                    ?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="2F1FD1"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'secondary_button_content',
                                                color: 'default',
                                            })
                                        }
                                        inputValue={
                                            data?.secondary_button_content
                                                ?.default
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button_content
                                                    ?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'secondary_button_content',
                                                color: 'hover',
                                            })
                                        }
                                        inputValue={
                                            data?.secondary_button_content
                                                ?.hover
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button_content
                                                    ?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'secondary_button_content',
                                                color: 'active',
                                            })
                                        }
                                        inputValue={
                                            data?.secondary_button_content
                                                ?.active
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Links
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.links?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="2013AC"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'links',
                                                color: 'default',
                                            })
                                        }
                                        inputValue={data?.links?.default}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.links?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="3A29E8"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'links',
                                                color: 'hover',
                                            })
                                        }
                                        inputValue={data?.links?.hover}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.links?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="5948FF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'links',
                                                color: 'active',
                                            })
                                        }
                                        inputValue={data?.links?.active}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <span className="details-table__color-title">
                                        Underlined
                                    </span>
                                    <Switch
                                        className="details-table__switch--main"
                                        checked={data?.links?.underlined}
                                        onChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'links',
                                                color: 'underlined',
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Icons
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper"></div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.icons?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="3F2DF3"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'icons',
                                                color: 'hover',
                                            })
                                        }
                                        inputValue={data?.icons?.hover}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Selectors
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.selectors?.active ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="3A29E8"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'selectors',
                                                color: 'active',
                                            })
                                        }
                                        inputValue={data?.selectors?.active}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Email button
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button?.default ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="3A29E8"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'email_button',
                                                color: 'default',
                                            })
                                        }
                                        inputValue={data?.email_button?.default}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button?.hover ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="2F1FD1"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'email_button',
                                                color: 'hover',
                                            })
                                        }
                                        inputValue={data?.email_button?.hover}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button?.active ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="2013AC"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'email_button',
                                                color: 'active',
                                            })
                                        }
                                        inputValue={data?.email_button?.active}
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <span className="details-table__color-title">
                                        Outlined
                                    </span>
                                    <Switch
                                        className="details-table__switch--main"
                                        checked={data?.email_button?.outlined}
                                        onChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'email_button',
                                                color: 'outlined',
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Email button content
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button_content
                                                    ?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'email_button_content',
                                                color: 'default',
                                            })
                                        }
                                        inputValue={
                                            data?.email_button_content?.default
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button_content
                                                    ?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'email_button_content',
                                                color: 'hover',
                                            })
                                        }
                                        inputValue={
                                            data?.email_button_content?.hover
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button_content
                                                    ?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>

                                    <CustomInput
                                        className="input-dark"
                                        placeholder="FFFFFF"
                                        onInputChange={(e) =>
                                            onChangeColors(e, {
                                                head: 'email_button_content',
                                                color: 'active',
                                            })
                                        }
                                        inputValue={
                                            data?.email_button_content?.active
                                        }
                                        pattern={
                                            '^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$'
                                        }
                                        title='Value must have 3 or 6 characters and contains characters "a-f", "A-F", "0-9"'
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
